module.exports = __webpack_public_path__ + "img/Paladin.754260f3.png";